export default __webpack_public_path__ + "static/press2-1e24f3a5c26e57cfb22b4d7e2121d7fb.png";